import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icons,
} from "@/components/ui";
import { useT } from "@/i18n";
import { framesDatasetMessages } from "@/i18n/messages/frames-dataset";

/**
 * A row's menu, shown on hover or focus at the row's end: Delete row sits
 * one step behind it, so a click meant for the cell next to it never
 * deletes. The status line then offers Undo.
 */
export function DatasetRowMenu({
  rowId,
  onDelete,
}: {
  rowId: string;
  onDelete: (rowId: string) => void;
}) {
  const t = useT(framesDatasetMessages);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="iconSm"
          className="opacity-0 focus-visible:opacity-100 group-hover:opacity-100 data-[state=open]:opacity-100"
          aria-label={t("rowMenu")}
          data-testid={`dataset-row-menu-${rowId}`}
        >
          <Icons.MoreHorizontal className="h-3.5 w-3.5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-40">
        <DropdownMenuItem
          destructive
          icon={<Icons.Trash2 />}
          onSelect={() => onDelete(rowId)}
          data-testid={`dataset-row-delete-${rowId}`}
        >
          {t("deleteRow")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
